export default {
  date: 'Dată',
  chooseExpDate: 'Alege o dată',
  filterExpDate: 'Filtrează după dată',
  experienceType: 'Tip',
  filterExperienceType: 'Filtrează după tip',
  experienceVibe: 'Atmosferă',
  filterExperienceVibe: 'Filtrează după atmosferă',
  search: 'Caută',
  viewCalendar: 'Calendar',
  back: 'Înapoi',
  previous: 'Anterior',
  next: 'Următor',
  noExperiences: 'Fără Experiențe',
  cancelChanges: 'Anulează modificările',
  saveChanges: 'Salvează modificările',
  removeFromReservation: 'Elimină din rezervare',
  addToCart: 'Adaugă în coș',
  proceedToCheckout: 'Continuă la plată',
  selectDate: 'Selectează data',
  startDate: 'Data de început',
  endDate: 'Data de sfârșit',
  submit: 'Trimite',
  filterExperienceTypeScreenReader:
    'Folosiți aceste filtre pentru a restrânge rezultatele. Conținutul se actualizează automat când un filtru este selectat.',
};
